(() => {
  if (window.__dommaSubscriptionSelectorLoaded) return;
  window.__dommaSubscriptionSelectorLoaded = true;

  class SubscriptionSelector {
    constructor() {
      this.init();
      this.setupGlobalListener();
    }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
    
    // Escucha evento del drawer para re-inicializar
    document.addEventListener('subscription:reinit', () => {
      this.setupEventListeners();
    });
  }

  setupGlobalListener() {
    // Listener global para actualizar el CTA cuando cambia la selección de suscripción
    document.addEventListener('subscription:selectionChanged', (event) => {
      this.updateCTAButton(event.detail);
    });
  }

  setupEventListeners() {
    const selectors = document.querySelectorAll('.subscription-selector-native');
    selectors.forEach(selector => this.setupSelectorListeners(selector));
  }

  getLocalProductRoot(element) {
    if (element && typeof element.closest === 'function') {
      return element.closest('.wt-product') || document;
    }
    return document;
  }

  getSelectorForm(selector) {
    const productRoot = this.getLocalProductRoot(selector);
    let form = productRoot.querySelector('form[data-type="add-to-cart-form"]');

    if (!form) {
      const formId = selector.querySelector('input[type="radio"][form]')?.getAttribute('form');
      if (formId) {
        form = document.getElementById(formId);
      }
    }

    return form;
  }

  getAssociatedSellingPlanRadios(selector, form) {
    if (!form) return [];

    const selectorRadios = Array.from(
      selector.querySelectorAll('input[type="radio"][name="selling_plan"]')
    );

    return selectorRadios.filter((radio) => {
      const explicitFormId = radio.getAttribute('form');
      if (explicitFormId) return explicitFormId === form.id;
      return form.contains(radio);
    });
  }

  cleanupLegacySellingPlanHiddenInputs(selector, form) {
    const associatedRadios = this.getAssociatedSellingPlanRadios(selector, form);
    if (!associatedRadios.length) return;

    const hiddenInputs = form.querySelectorAll('input[type="hidden"][name="selling_plan"]');
    hiddenInputs.forEach((input) => input.remove());
  }

  setupSelectorListeners(selector) {
    if (selector.dataset.subscriptionInitialized === 'true') {
      return;
    }
    selector.dataset.subscriptionInitialized = 'true';

    const radioInputs = selector.querySelectorAll('input[type="radio"]');
    const form = this.getSelectorForm(selector);
    if (form) {
      this.cleanupLegacySellingPlanHiddenInputs(selector, form);
    }
    
    radioInputs.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.handleRadioChange(e, selector);
      });
    });

    this.bindFormSubmit(selector);


    const initiallyChecked = selector.querySelector('input[type="radio"]:checked');
    if (initiallyChecked) {
      this.handleRadioChange({ target: initiallyChecked }, selector);
    } else {
      const firstEnabled = selector.querySelector('input[type="radio"]:not([disabled])');
      if (firstEnabled) {
        firstEnabled.checked = true;
        this.handleRadioChange({ target: firstEnabled }, selector);
      } else {
        this.updateHiddenInputs(selector);
      }
    }
  }

  bindFormSubmit(selector) {
    const form = this.getSelectorForm(selector);

    if (!form) return;
    if (form.dataset.subscriptionSubmitBound === 'true') return;
    form.dataset.subscriptionSubmitBound = 'true';

    form.addEventListener('submit', () => {
      this.syncSelectionToForm(selector, form);
    }, true);
  }

  syncSelectionToForm(selector, form) {
    const checkedRadio = selector.querySelector('input[type="radio"]:checked');
    if (!checkedRadio || !form) return;

    const variantInput = form.querySelector('input[name="id"]');

    if (checkedRadio.dataset.radioType === 'one_time_purchase') {
      if (variantInput && checkedRadio.dataset.variantId) {
        variantInput.value = checkedRadio.dataset.variantId;
      }
    } else if (checkedRadio.dataset.radioType === 'selling_plan') {
      if (variantInput && checkedRadio.dataset.variantId) {
        variantInput.value = checkedRadio.dataset.variantId;
      }
    }
  }

  handleRadioChange(event, selector) {
    const radio = event.target;
    
    this.updateHiddenInputs(selector);
    
    this.updateMainProductForm(radio);
    
    // Lanzar evento personalizado con la información de la selección
    this.dispatchSelectionEvent(radio);
    
    this.updateCTAFromRadio(radio);
  }

  updateCTAFromRadio(radio) {

    const selector = radio.closest('.subscription-selector-native');
    const form = selector ? this.getSelectorForm(selector) : this.getSelectorForm(radio.closest('.wt-product') || document);
    
    if (!form) return;

    const ctaButton = form.querySelector('button[name="add"]');
    if (!ctaButton) return;

    const showPer =
      typeof radio.dataset.showPer !== 'undefined'
        ? radio.dataset.showPer === 'true'
        : radio.dataset.radioType === 'selling_plan';

    const detail = {
      variantPrice: radio.dataset.variantPrice || null,
      variantCompareAtPrice: radio.dataset.variantCompareAtPrice || null,
      isSubscription: radio.dataset.radioType === 'selling_plan',
      showPer
    };

    this.updateCTAPrices(ctaButton, detail);
  }

  updateHiddenInputs(selector) {
    const checkedRadio = selector.querySelector('input[type="radio"]:checked');
    
    if (!checkedRadio) return;

    const form = this.getSelectorForm(selector);
    const variantInput = form?.querySelector('input[name="id"]');
    if (variantInput && checkedRadio.dataset.variantId) {
      variantInput.value = checkedRadio.dataset.variantId;
    }
  }

  updateMainProductForm(radio) {
    const selector = radio.closest('.subscription-selector-native');
    const mainForm = selector ? this.getSelectorForm(selector) : null;
    
    if (!mainForm) return;

    const variantInput = mainForm.querySelector('input[name="id"]');

    if (radio.dataset.radioType === 'one_time_purchase') {
      if (variantInput) variantInput.value = radio.dataset.variantId;
    } else if (radio.dataset.radioType === 'selling_plan') {
      if (variantInput) variantInput.value = radio.dataset.variantId;
    }

    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  dispatchSelectionEvent(radio) {
    const showPer =
      typeof radio.dataset.showPer !== 'undefined'
        ? radio.dataset.showPer === 'true'
        : radio.dataset.radioType === 'selling_plan';

    const eventData = {
      radioType: radio.dataset.radioType,
      variantId: radio.dataset.variantId,
      sellingPlanId: radio.dataset.sellingPlanId || null,
      isSubscription: radio.dataset.radioType === 'selling_plan',
      isOneTimePurchase: radio.dataset.radioType === 'one_time_purchase',
      variantPrice: radio.dataset.variantPrice || null,
      variantCompareAtPrice: radio.dataset.variantCompareAtPrice || null,
      showPer,
      element: radio
    };

    // Lanzar evento en el documento para que pueda ser escuchado globalmente
    const customEvent = new CustomEvent('subscription:selectionChanged', {
      detail: eventData,
      bubbles: true,
      cancelable: false
    });
    
    document.dispatchEvent(customEvent);
    
  }

  updateCTAButton(detail) {
    if (!detail) return;

    const selector = detail.element?.closest('.subscription-selector-native');
    const form = selector ? this.getSelectorForm(selector) : null;
    
    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput && detail.variantId) {
      variantInput.value = detail.variantId;
    }

    const ctaButton = form.querySelector('button[name="add"]');
    if (ctaButton) {
      this.updateCTAPrices(ctaButton, detail);
    }
  }

  updateCTAPrices(button, detail) {
    const priceElement = button.querySelector('[data-price]');
    const compareElement = button.querySelector('[data-compare]');
    const perElement = button.querySelector('[data-per]');

    if (!priceElement) return;

    if (detail.variantPrice) {
      priceElement.textContent = detail.variantPrice;
    }

    if (perElement) {
      const shouldShowPer = typeof detail.showPer === 'boolean' ? detail.showPer : detail.isSubscription;
      perElement.style.display = shouldShowPer ? '' : 'none';
    }

    if (compareElement) {
      if (detail.isSubscription && detail.variantCompareAtPrice && detail.variantCompareAtPrice !== detail.variantPrice) {
        compareElement.textContent = detail.variantCompareAtPrice;
        compareElement.style.display = '';
      } else if (!detail.isSubscription && detail.variantCompareAtPrice && detail.variantCompareAtPrice !== detail.variantPrice) {
        compareElement.textContent = detail.variantCompareAtPrice;
        compareElement.style.display = '';
      } else {
        compareElement.style.display = 'none';
      }
    }
  }
  }

  new SubscriptionSelector();
})();